import { buriedPagePoint } from '@/pages/opinion/operationLog/buriedPoint';
import { useEffect } from 'react';

export default function useReportBuryingPoint({
  listMenu,
  match,
  location,
}: {
  listMenu: any;
  match: any;
  location: any;
}) {
  function getReportPageName(listMenu: any, name: string) {
    try {
      let reportList = listMenu.filter((item) => item.name_en === 'Report')[0];
      let target = reportList.opinion_list?.filter(
        (item) =>
          item.name_en?.replaceAll(/\s/gi, '') === name ||
          item.name_en === name ||
          decodeURIComponent(name) === item.name_en,
      )[0];

      if (
        target.name_en === 'Insights Report' ||
        target.name_en === 'Newsletter'
      )
        return 'newsletter'; // 特殊处理 Insights 上报

      return target.name_en;
    } catch (error) {
      return null;
    }
  }

  useEffect(() => {
    let reportName = getReportPageName(
      listMenu,
      match?.params?.reportId || location?.query?.name,
    );
    if (reportName !== null) {
      buriedPagePoint(undefined, reportName);
    }
  }, [listMenu, window.location.href]);
}
